import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Info: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M12 16v-4' }],
    ['path', { d: 'M12 8h.01' }],
  ],
];

export default Info;
